import React, { useEffect, useState } from 'react';
import generateStyles from './styles';
import { Typography, TextField, MenuItem, makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {Customer as CustomerModel, CustomerRef} from '../customer.model';
import { Payment } from '../../payments/payments.model';
import { Invoice } from '../../invoices/invoice.model';
import { getAllInvoicesOfACustomer } from '../../invoices/invoice.service';
import { getAllPaymentsOfACustomer } from '../../payments/payment.service';
import { getBalance } from './transaction.service';
import { Balance } from './transaction.model';
import { formatDateInDDMMYYYY, getHeaderForPrint } from '../../../../../common/common.service';
import { Skeleton } from '@material-ui/lab';
import jsPDF from 'jspdf';
import Loading from '../../../../../components/shared/Loading';
import MUIDataTable from 'mui-datatables';
import { getUser } from '../../../../login/login.service';
// import { getInvoicesByCustomer } from '../../../../../common/firestore.service';
// import { getCustomer } from '../customer.service';


const Customer = ({history, match, customerList,filterYear }: any) => {
    const useStyles = generateStyles();
    const classes:any = useStyles();
    const currentDate = new Date();
    const [ filterMonth, setFilterMonth ] = useState<any>(currentDate.getMonth());
    const [ payments, setPayments ] = useState<Payment[]>([]);
    const [ invoices, setInvoices ] = useState<Invoice[]>([]);
    const [ balance , setBalance ] = useState<Balance>(new Balance({}));
    const [ transactionDetailsReady, setTransactionDetailsReady ] = useState<boolean>(false);
    let mounted = true;
    const [ rows, setRows ] = useState<any[]>([
        {
            date: <Skeleton variant="text" animation="wave" />,
            transaction: <Skeleton variant="text" animation="wave" />,
            details: <Skeleton variant="text" animation="wave" />,
            amount: <Skeleton variant="text" animation="wave" />,
            payment: <Skeleton variant="text" animation="wave" />,
            balance: <Skeleton variant="text" animation="wave" />,
        },
        {
            date: <Skeleton variant="text" animation="wave" />,
            transaction: <Skeleton variant="text" animation="wave" />,
            details: <Skeleton variant="text" animation="wave" />,
            amount: <Skeleton variant="text" animation="wave" />,
            payment: <Skeleton variant="text" animation="wave" />,
            balance: <Skeleton variant="text" animation="wave" />,
        },
        {
            date: <Skeleton variant="text" animation="wave" />,
            transaction: <Skeleton variant="text" animation="wave" />,
            details: <Skeleton variant="text" animation="wave" />,
            amount: <Skeleton variant="text" animation="wave" />,
            payment: <Skeleton variant="text" animation="wave" />,
            balance: <Skeleton variant="text" animation="wave" />,
        }
    ]);
    const [ tableRows, setTableRows ] = useState<any[]>([]);
    const [ openingBalance, setOpeningBalance ] = useState<number>(0);
    const [ invoiceAmount, setInvoiceAmount ] = useState<number>(0);
    const [ amountReceived, setAmountReceived ] = useState<number>(0);
    const [ balanceAmount , setBalanceAmount ] = useState<number>(0);
    let [loading, setLoading]   =   useState(false);


    // const [ customer, setCustomer ] = useState<CustomerModel>(new CustomerModel({}));
    let customerFromProp = customerList.filter((datum: CustomerModel) => datum.id === match.params.id)[0];
    if(!customerFromProp) {
        customerFromProp = new CustomerRef({});
    }
    // const fetchAndSetCustomer = async (id: string) => {
    //     let customer = await getCustomer(id);
    //     setCustomer(customer)
    // }

    const fetchTransactionDetails = async () =>  {
        console.log(filterMonth)
        // const promiseArray = [
        //     getAllInvoicesOfACustomer(match.params.id, filterMonth, filterYear),
        // getAllPaymentsOfACustomer(match.params.id, filterMonth, filterYear),
        //     getBalance(filterYear, filterMonth, match.params.id)
        // ];

        // const [invoices, payments, balance] = await Promise.all(promiseArray);
        // console.log(invoices, payments, balance);
        getAllInvoicesOfACustomer(match.params.id, filterMonth, filterYear, (invoices: Invoice[]) => {
            getAllPaymentsOfACustomer(match.params.id, filterMonth, filterYear, (payments: Payment[]) => {
                getBalance(filterYear, filterMonth, match.params.id, (balance: Balance) => {
                    console.log(balance)

                    if(mounted) {
                        setInvoices(invoices);
                        setPayments(payments);
                        setBalance(balance);
                        setTransactionDetailsReady(true);
                    }
                });
            });
        });
    };

    const options: any = {
        selectableRows: 'none',
         setRowProps: (columns: any, value: any, tableMeta: any, updateValue: any) => {
          return {
            style: {boxShadow: '0px 3px 5px #00000029', borderRadius: 6 }
          };
        },
        pagination: false,
        onRowClick: (rowData:string[], rowMeta: {dataIndex: number, rowIndex: number}) => {
            console.log(rowData[0]);
            if(rowData[0]) {
                history.push(rowData[0]);
            }
        }
      };

    const columns: any = [
        {
            name: 'id',
            label: 'ID',
            options: {
                display: false
            }
        },
        {
          name:"date",
          label: 'Date',
          options: {
            sort: false,
            setCellHeaderProps: (value: any) => ({ style: { display: 'flex', height: '44px', justifyContent: 'center', alignItems: 'center' } }),
            setCellProps: (cellValue: any, rowIndex: any, columnIndex: any) => ({style: {textAlign: 'center !important', borderBottomLeftRadius: 6, borderTopLeftRadius: 6}}),
            customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
              return (
                <div style={{textAlign: 'center', color:"#112B42", padding: '5px 0'}}>{value}</div>
              );
            }
          }
        },
        {
          name:"transaction",
          label: 'Transaction',
          options: {
              sort: false,
            setCellHeaderProps: (value: any) => ({className: makeStyles({'rateHeader': {'& > div': {textAlign: 'center'}}})().rateHeader}),
            customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
              // console.log(rows)
              return (
                <div style={{color:"#112B42", textAlign: 'center', padding: '5px 0'}}>{value}</div>
              );
            }
          }
        }, 
        {
          name: 'details',
          label:"Details",
          options: {
              sort: false,
              setCellHeaderProps: (value: any) => ({className: makeStyles({'rateHeader': {'& > div': {textAlign: 'center'}}})().rateHeader}),
            customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
              // console.log(rows)
              return (
                <div style={{color:"#112B42", textAlign: 'center', padding: '5px 0'}}>{value}</div>
              );
            }
          }
        },
        { 
          name: "amount",
          label:"Amount",
          options: {
              sort: false,
              setCellHeaderProps: (value: any) => ({className: makeStyles({'rateHeader': {'& > div': {textAlign: 'center'}}})().rateHeader}),
            customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
              // console.log(rows)
              return (
                <div style={{color:"#112B42", textAlign: 'center', padding: '5px 0'}}> {(transactionDetailsReady && value) && '₹'} {value}</div>
              );
            }
          }
        }, 
        {
          name: "payment",
          label:"Payment",
          options: {
              sort: false,
              setCellHeaderProps: (value: any) => ({className: makeStyles({'rateHeader': {'& > div': {textAlign: 'center'}}})().rateHeader}),
            customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
              // console.log(rows)
              return (
                <div style={{color:"#112B42", textAlign: 'center', padding: '5px 0'}}> {(transactionDetailsReady && value) && '₹'} {value}</div>
              );
            }
          }
        }, 
        {
          name: "balance",
          label:"Balance",
          options: {
              sort: false,
              setCellHeaderProps: (value: any) => ({className: makeStyles({'rateHeader': {'& > div': {textAlign: 'center'}}})().rateHeader}),
            customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
              return (
                <div className="txt-al-r" style={{textAlign:"center", color:"#112B42", padding: '5px 0'}}> {(transactionDetailsReady && value) && '₹'}  {value}</div>
              );
            }
          }
        }
      ];

    const createRow = (data: any, type: string) => {
        let row: any;
        switch(type) {
            case 'OPENING_BALANCE':
                row = {
                    id: false,
                    date: data.date,
                    transaction: '',
                    details: 'Opening Balance',
                    amount: '',
                    payment: '',
                    balance: data.balance.toLocaleString('en-IN')
                };
                break;
            case 'PAYMENT':
                row = {
                    id: data.id,
                    date: data.date,
                    transaction: '',
                    details: 'Payment',
                    amount: '',
                    payment: data.payment.toLocaleString('en-IN'),
                    balance: data.balance.toLocaleString('en-IN')
                };
                console.log(row)
                break;

            case 'INVOICE':
                row = {
                    id: data.id,
                    date: data.date,
                    transaction: data.details,
                    details: 'Invoice',
                    amount: data.amount.toLocaleString('en-IN'),
                    payment: '',
                    balance: data.balance.toLocaleString('en-IN')
                };
                break;
        }
        return row;
    }

    const createTableRow = (data: any, type: string) => {
        let row: any;
        switch(type) {
            case 'OPENING_BALANCE':
                row = (
                    `<tr style="font-size: 6px;">
                            <td>${data.date}</td>
                            <td></td>
                            <td>Opening Balance</td>
                            <td></td>
                            <td></td>
                            <td>${data.balance}</td>
                    </tr>`
                );
                break;
            case 'PAYMENT':
                row = (
                    `<tr style="font-size: 6px;">
                            <td>${data.date}</td>
                            <td></td>
                            <td>Payment</td>
                            <td></td>
                            <td>${data.payment}</td>
                            <td>${data.balance}</td>
                    </tr>`
                );
                break;

            case 'INVOICE':
                row = (
                    `<tr style="font-size: 6px;">
                            <td>${data.date}</td>
                            <td>${data.details}</td>
                            <td>Invoice</td>
                            <td>${data.amount}</td>
                            <td></td>
                            <td>${data.balance}</td>
                    </tr>`
                );
                break;
        }
        return row;
    }

    const prepareRowData = () => {
        let currentBalance = balance.openingBalance;
        let invoiceAmount = 0;
        let paymentReceived = 0;
        setOpeningBalance(balance.openingBalance);
        // Add opening balance first!
        const firstDayOfMonth = `${currentDate.getFullYear()}-${filterMonth!==12?filterMonth + 1:1}`
        let newRows = [
            createRow({
                date: `01/${filterMonth!==11?filterMonth+1:1}/${filterMonth<4? filterYear:filterYear-1}`,
                amount: '',
                balance: currentBalance
            }, 'OPENING_BALANCE')
        ];

        let tableRows = [
            createTableRow({
                date: formatDateInDDMMYYYY(new Date(firstDayOfMonth)),
                amount: '',
                balance: currentBalance
            }, 'OPENING_BALANCE')
        ]

        const invoicesAndPayments = [...invoices, ...payments].sort((a: any, b: any) => a.date - b.date);

        // console.log(invoicesAndPayments);
        
        newRows.push(...invoicesAndPayments.map((data: any) => {
            let rowType = data.mode ? 'PAYMENT': 'INVOICE';
            const rowData = {
                id: rowType === 'INVOICE' ? `/dashboard/invoices/${data.id}`: `/dashboard/payments/${data.id}`,
                date: formatDateInDDMMYYYY(new Date(data.date)),
                details: rowType === 'INVOICE' ? data.id: '',
                amount: rowType === 'INVOICE' ? data.total : '',
                payment: rowType === 'PAYMENT' ? data.amount: '',
                balance: rowType === 'PAYMENT' ? currentBalance - data.amount : currentBalance + data.total
            };
            if(rowType === 'INVOICE') invoiceAmount += data.total;
            else paymentReceived += data.amount;
            currentBalance = rowData.balance;
            console.log(currentBalance)
            tableRows.push(createTableRow(rowData, rowType))
            return createRow(rowData, rowType);
        }));

        if(mounted) {
            setInvoiceAmount(invoiceAmount);
            setAmountReceived(paymentReceived);
            setBalanceAmount(currentBalance);
    
            setRows(newRows);
            setTableRows(tableRows);
        }
    }

    // Triggered when match prop is changed!
    useEffect(() => {
        setTransactionDetailsReady(false);
        // fetchAndSetCustomer(match.params.id);
        // console.log('Fetch Invoices and Payments docs for transaction details');
        if(match.params.id) {
            fetchTransactionDetails();
        }
        // getInvoicesByCustomer();
    }, [match, filterMonth, filterYear]);

    useEffect(() => {
        if(mounted) {
            setRows([
                {
                    date: <Skeleton variant="text" animation="wave" />,
                    transaction: <Skeleton variant="text" animation="wave" />,
                    details: <Skeleton variant="text" animation="wave" />,
                    amount: <Skeleton variant="text" animation="wave" />,
                    payment: <Skeleton variant="text" animation="wave" />,
                    balance: <Skeleton variant="text" animation="wave" />,
                },
                {
                    date: <Skeleton variant="text" animation="wave" />,
                    transaction: <Skeleton variant="text" animation="wave" />,
                    details: <Skeleton variant="text" animation="wave" />,
                    amount: <Skeleton variant="text" animation="wave" />,
                    payment: <Skeleton variant="text" animation="wave" />,
                    balance: <Skeleton variant="text" animation="wave" />,
                },
                {
                    date: <Skeleton variant="text" animation="wave" />,
                    transaction: <Skeleton variant="text" animation="wave" />,
                    details: <Skeleton variant="text" animation="wave" />,
                    amount: <Skeleton variant="text" animation="wave" />,
                    payment: <Skeleton variant="text" animation="wave" />,
                    balance: <Skeleton variant="text" animation="wave" />,
                }
            ]);
        }
        if(transactionDetailsReady) {
            prepareRowData()
        }
    }, [transactionDetailsReady]);

    // componentDidMount
    useEffect(() => {
        return () => {
            mounted = false;
        }
    }, [])

    const handleFilterMonthChange = (e: any) => {
        setFilterMonth(e.target.value);
    }


    const preparePDF = () => {
        setLoading(true);
        const user = getUser();
        const transactionSummary = `
            <main style="width: 425px; height: 610px;display: flex; flex-direction: column;">


                <hr />

                <div style="height:text-align: center;display: flex; flex-direction: column; justify-content: center; margin-bottom: 20px">
                    <h3 style="text-align: center;margin: 0">Transaction Summary</h3>
                    <h6 style="text-align: center;margin: 0">${filterMonth+1}/${filterYear}</h6>
                </div>

                ${getHeaderForPrint({user})}

                <div style="margin-top: 20px; display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100% !important; padding: 0 8px">
                    <div style="font-size: 6px; width: 90%; margin-bottom: 10px; display: flex; justify-content: space-around">
                        <div>
                            <p>Opening Balance</p>
                            <p>Rs.${openingBalance.toLocaleString('en-IN')}</p>
                        </div>
                        <div>
                            <p>Invoice Amount</p>
                            <p>Rs.${invoiceAmount.toLocaleString('en-IN')}</p>
                        </div>
                        <div>
                            <p>Amount Received</p>
                            <p>Rs.${amountReceived.toLocaleString('en-IN')}</p>
                        </div>
                        <div>
                            <p>Balance Amount</p>
                            <p>Rs.${balanceAmount.toLocaleString('en-IN')}</p>
                        </div>
                    </div>
                    <table style="width: 100%">
                        <tr style="font-size: 6px;background-color: #f1f1f1;">
                            <td>Date</td>
                            <td>Transaction</td>
                            <td>Details</td>
                            <td>Amount</td>
                            <td>Payment</td>
                            <td>Balance</td>
                        </tr>

                        ${tableRows.join('')}
                    </table>
                </div>
            </main>
        `;
        var doc = new jsPDF({
            orientation: 'p',
            unit: 'px',
            format: 'a4'
           });
        doc.html(transactionSummary, {
            callback: function (doc) {
            // doc.save();
            doc.autoPrint();
            var oHiddFrame = document.createElement("iframe");
            oHiddFrame.style.position = "fixed";
            oHiddFrame.style.visibility = "hidden";
            oHiddFrame.src = doc.output("bloburl").toString();
            document.body.appendChild(oHiddFrame);
            oHiddFrame.onload = () => {
                if(oHiddFrame.contentWindow) {
                    setLoading(false);
                    oHiddFrame.contentWindow.focus();
                }
            };
            },
            x: 10,
            y: 10
        });
    }
    return (
        <>
            {
                customerList.length === 0
                ?
                    <div style={{width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <h2>No customer data found. Add some customers :-)</h2>
                    </div>
                :

                    <main className={classes.main}>
                        <div className={classes.header}>
                            <Typography variant="h6" component="h1" style={{ fontSize:"20px", color:"#112B42", fontWeight:600}}>{ customerFromProp.name }</Typography>
                            <div style={{display: 'flex'}}>
                                <Link to={`/dashboard/customer/${customerFromProp.id}`} style={{margin: '4px 10px'}}>
                                    <span className={classes.alignCenter}>
                                        <img src="/img/edit.png" alt="pencil icon" style={{width:"17px", marginRight:"5px"}}/>
                                        Edit
                                    </span>
                                </Link>
                                
                                <Link to={`/dashboard/invoices/new/?customerId=${customerFromProp.id}`} style={{margin: '0 10px'}}>
                                    <span className={classes.alignCenter}>
                                        <AddIcon />
                                        New Transaction
                                    </span>
                                </Link>
                            </div>
                        </div>
                        <div className={classes.bottomScreen}>
                            <div className={classes.rightScreen}>
                                <div className={classes.transactionDetailsTop}>
                                    <div className={classes.transactionDetailsHeader}>
                                        <Typography style={{fontWeight: 'bolder', color: '#2F3947'}}>Transaction Details</Typography>
                                        <div className={classes.transactionDetailsControls}>
                                            {/* <span onClick={preparePDF} className={`${classes.alignCenter} cursor-pointer`}>
                                                <img src="/img/pdf1.png" alt="pencil icon" style={{marginRight:"7px", width:"16px", color:"red"}}/>
                                                Pdf
                                            </span> */}
                                        </div>
                                    </div>
                                    <div className={classes.transactionDetailsAmounts}>
                                        <div style={{flex: 1}}>
                                            <span>Opening Balance</span>
                                            <span> { transactionDetailsReady ? <>₹ {openingBalance.toLocaleString('en-IN')}</> : <Skeleton width="50px" variant="text" animation="wave" /> }</span>
                                        </div>
                                        <div style={{flex: 1}}>
                                            <span>Invoice Amount</span>
                                            <span> { transactionDetailsReady ? <>₹ {invoiceAmount.toLocaleString('en-IN')}</> : <Skeleton width="50px" variant="text" animation="wave" /> }</span>
                                        </div>
                                        <div style={{flex: 1}}>
                                            <span>Amount Received</span>
                                            <span> { transactionDetailsReady ? <>₹ {amountReceived.toLocaleString('en-IN')}</> : <Skeleton width="50px" variant="text" animation="wave" /> }</span>
                                        </div>
                                        <div style={{flex: 1}}>
                                            <span style={{textAlign:'right'}}>Balance Amount</span>
                                            <span style={{textAlign:'right'}}> { transactionDetailsReady ? <>₹ {balanceAmount.toLocaleString('en-IN')}</> : <Skeleton variant="text" animation="wave" /> }</span>
                                        </div>

                                        <div style={{display: 'flex', flexDirection: 'row', flex: 3, marginLeft: 25}}>
                                            <div>
                                                <TextField
                                                    style={{color: '#96A9C3 !important', width: 150, padding: '0 10px', borderRadius: 5, marginRight: 25,}}
                                                    InputProps={{disableUnderline: true}}
                                                    // labelId="demo-simple-select-label"
                                                    // label="Age"
                                                    id="demo-simple-select"
                                                    // onChange={handleChange}
                                                    className={classes.drop}
                                                    select
                                                    SelectProps={{IconComponent:  (props) => <ExpandMoreIcon {...props}/>}}
                                                    value={filterMonth}
                                                    onChange={handleFilterMonthChange}
                                                >
                                                    <MenuItem value={-1}>Select month</MenuItem>
                                                    
                                                    <MenuItem value={3}>April</MenuItem>
                                                    <MenuItem value={4}>May</MenuItem>
                                                    <MenuItem value={5}>June</MenuItem>
                                                    <MenuItem value={6}>July</MenuItem>
                                                    <MenuItem value={7}>August</MenuItem>
                                                    <MenuItem value={8}>September</MenuItem>
                                                    <MenuItem value={9}>October</MenuItem>
                                                    <MenuItem value={10}>November</MenuItem>
                                                    <MenuItem value={11}>December</MenuItem>
                                                    <MenuItem value={0}>January</MenuItem>
                                                    <MenuItem value={1}>February</MenuItem>
                                                    <MenuItem value={2}>March</MenuItem>
                                                    <MenuItem value={12}>All Month</MenuItem>
                                                </TextField>
                                            </div>
                                            <div>
                                               {/* <TextField
                                                    style={{color: '#96A9C3 !important', width: 100, padding: '0 10px', borderRadius: 5 }}
                                                    InputProps={{disableUnderline: true}}
                                                    // labelId="demo-simple-select-label"
                                                    // label="Age"
                                                    id="demo-simple-select"
                                                    // onChange={handleChange}
                                                    className={classes.drop}
                                                    select
                                                    SelectProps={{IconComponent:  (props) => <ExpandMoreIcon {...props}/>}}
                                                    value={filterYear}
                                                    onChange={handleFilterYearChange}
                                                >
                                                    <MenuItem value={-1}>Select year</MenuItem>
                                                    <MenuItem value={2020}>2020</MenuItem>
                                                    <MenuItem value={2021}>2021</MenuItem>
                                                    <MenuItem value={2022}>2022</MenuItem>
                                                    <MenuItem value={2023}>2023</MenuItem>
                                                    <MenuItem value={2024}>2024</MenuItem>
                                                    <MenuItem value={2025}>2025</MenuItem>
                                               </TextField>*/}
                                            </div>
                                            <span onClick={preparePDF} style={{paddingLeft: 20}} className={`${classes.alignCenter} cursor-pointer`}>
                                                <img src="/img/pdf1.png" alt="pencil icon" style={{marginRight:"7px", width:"16px", color:"red"}}/>
                                                Pdf
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className={classes.transactionDetailsBottom}>
                                    <MUIDataTable title={"ACME Employee list"}data={rows} columns={columns} options={options} />
                                </div>
                            </div>
                        </div>
                    <Loading loading={loading} text="Loading..."/>
                    </main>
            }
        </>
    );
};

export default Customer;